<template>
  <section class="whitepaper-section">
    <div class="container">
      <div class="content-wrapper">
        <!-- 左侧：文档说明区 60% -->
        <div class="left-panel">
          <div class="label">WHITEPAPER</div>
          <h2 class="title">商业模式白皮书</h2>
          <p class="subtitle">包含商业结构、技术架构与发展路线说明</p>
          
          <div class="content-list">
            <div class="list-item">
              <svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>市场结构分析</span>
            </div>
            <div class="list-item">
              <svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>商业模型拆解</span>
            </div>
            <div class="list-item">
              <svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>三年发展路线</span>
            </div>
            <div class="list-item">
              <svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 6L9 17l-5-5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>融资与资源规划</span>
            </div>
          </div>
        </div>

        <!-- 右侧：资料获取区 40% -->
        <div class="right-panel">
          <form class="download-form" @submit.prevent="handleDownload">
            <div class="form-group">
              <input 
                v-model="form.email" 
                type="email" 
                placeholder="您的邮箱地址" 
                required
                class="email-input"
              >
              <button type="submit" class="submit-button" :disabled="isSubmitting">
                <span v-if="!isSubmitting">获取白皮书</span>
                <span v-else>发送中...</span>
              </button>
            </div>
          </form>
          
          <p class="privacy-note">仅用于发送资料，不做营销用途</p>
          <p v-if="message" :class="['status-text', status]">
            {{ message }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhitepaperDownload',
  data() {
    return {
      form: {
        email: ''
      },
      isSubmitting: false,
      message: '',
      status: ''
    }
  },
  methods: {
    async handleDownload() {
      if (this.isSubmitting) return

      if (!this.form.email) return

      this.isSubmitting = true
      this.message = ''
      this.status = ''

      try {
        const res = await fetch('/api/whitepaper-request', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: this.form.email })
        })

        if (!res.ok) {
          throw new Error('Request failed')
        }

        this.status = 'success'
        this.message = '提交成功，请查收邮箱中的白皮书链接（如未收到可检查垃圾邮箱）。'
        this.form.email = ''
      } catch (e) {
        this.status = 'error'
        this.message = '提交失败，请稍后重试或通过商务联系方式获取白皮书。'
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.whitepaper-section {
  padding: 6rem 2rem;
  background: #070B14;
  position: relative;
  overflow: hidden;
}

.whitepaper-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    linear-gradient(0deg, rgba(0, 217, 255, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 217, 255, 0.01) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 4rem;
  align-items: center;
}

/* ===== 左侧面板 ===== */
.left-panel {
  padding-right: 2rem;
}

.label {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: #00D9FF;
  text-transform: uppercase;
  margin-bottom: 1rem;
  opacity: 0.8;
}

.title {
  font-size: 2.4rem;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 0.75rem;
  line-height: 1.2;
}

.subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.content-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.list-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.75);
}

.check-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  color: #00D9FF;
  stroke-width: 2.5;
}

/* ===== 右侧面板 ===== */
.right-panel {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.download-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.form-group {
  display: flex;
  gap: 0.75rem;
  align-items: stretch;
}

.email-input {
  flex: 1;
  padding: 12px 16px;
  background: #0B1220;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  color: #FFFFFF;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.email-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.email-input:focus {
  outline: none;
  border-color: rgba(0, 217, 255, 0.3);
  background: #0B1220;
}

.submit-button {
  padding: 12px 32px;
  background: #0B1220;
  color: #FFFFFF;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  text-transform: none;
}

.submit-button:hover {
  background: #111B2E;
  border-color: rgba(255, 255, 255, 0.2);
}

.privacy-note {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

.status-text {
  margin-top: 0.5rem;
  font-size: 0.8rem;
  text-align: center;
}

.status-text.success {
  color: #4ade80;
}

.status-text.error {
  color: #f97373;
}

/* ===== 响应式设计 ===== */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .left-panel {
    padding-right: 0;
  }

  .title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .whitepaper-section {
    padding: 4rem 1.5rem;
  }

  .title {
    font-size: 1.6rem;
  }

  .subtitle {
    font-size: 0.95rem;
  }

  .content-list {
    gap: 1rem;
  }

  .list-item {
    font-size: 0.9rem;
  }

  .form-group {
    flex-direction: column;
  }

  .email-input,
  .submit-button {
    width: 100%;
  }
}
</style>
